(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dorimm-related-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const load = async (section) => {
    if (!section?.dataset.productRecommendationsUrl || section.dataset.loaded === "true") return;
    section.dataset.loaded = "true";
    try {
      const response = await fetch(section.dataset.productRecommendationsUrl);
      if (!response.ok) throw new Error("Recommendations unavailable");
      const markup = await response.text();
      const documentFragment = new DOMParser().parseFromString(markup, "text/html");
      const replacement = documentFragment.querySelector("[data-product-recommendations]");
      if (!replacement) return;
      section.replaceWith(replacement);
      replacement.dataset.loaded = "true";
      document.dispatchEvent(new CustomEvent("dorimm:recommendations:loaded", { detail: { root: replacement } }));
    } catch (_error) {
      section.hidden = true;
    }
  };
  document.querySelectorAll("[data-product-recommendations]").forEach(load);
  document.addEventListener("shopify:section:load", (event) => load(event.target.querySelector("[data-product-recommendations]")));
})();

  } catch(e) { console.error(e); }
})();
})();
